<template>
    <div class="configure-container">
        <div class="configure-title-section">
            <div>
                <div class="back-link " @click="goBackClick()"> {{'< BACK'}} </div>
                <div class="configure-title">Configure Metrics</div>
                <div class="configure-subtitle" style= "margin-left: 28px;font-weight:10px;padding-bottom:20px;">Edit category or set decimal rules. Mark them as active or in-active.</div>
            </div>
            <div style="margin-right: 20px;">
                <input type="text" placeholder="Search Metric" v-model="searchTerm" class="search-metrics" />
                <img  style="margin-top: 4px; margin-left: -40px; margin-right: 65px; padding: 10px 0px 14px;width:22px;" src="../assets/img/search-logo.png" alt="search-metrics"/>
            </div>
        </div>
        <div class="configure-view-section" :style="{height: `${maxHeight - 214}px`}">
            <div class="metric-configure-read">
                <div class="metric-form">
                    <div class="form-field-aarp" style="width: 150px">
                        <div class="filter-label">Year</div>
                        <div style="width: 160px; display: flex;">
                            <!--<select :disabled="!years" style="width: 130px;" class="form-control" v-model="modalSelectedYear">
                                <option value="">Select year </option>
                                <option v-for="(yearObj,year) in years" :key="year" :value="year">{{year}}</option>
                            </select>-->
                            <div style="margin-bottom:28px; margin-left: 4px;margin-top: 6px;">
                                <datepicker :calendar-class="'vdp-datepicker'" input-class='datePicker-input-class' :value="modalSelectedYear" 
                                v-model="modalSelectedYear" :disabled="!years" placeholder="Select Year" @selected="setYear()" 
                                @opened="displayRequiredYears()" 
                                name="years"  :minimum-view="'year'" :format="'YYYY'" :maximum-view="'year'" 
                                :initial-view="'year'" :disabled-dates="disabledDates"></datepicker></div>
                            <div v-if="!years">
                                <img style="margin-top:6px; margin-left: 7px; width:26px;" src="../assets/img/ajax-loader.gif" alt="loading data..." />
                            </div>
                        </div>
                    </div>
                    <div class="form-field-aarp" style="width: 200px">
                        <div style="margin-bottom:4px; margin-left:70px;margin-top:6px;" class="filter-label">Program Name</div>
                        <select style="margin-left:70px" class="form-control" :disabled="modalPrograms.length == 0" v-model="modalSelectedProgram">
                            <option value="">Select program name</option>
                            <option v-for="program in modalPrograms" :value="program" :key="program">{{program}}</option>
                        </select>
                    </div>
                    <div class="form-field-aarp" style="align-self: flex-end;">
                        <button style="margin-left:75px; margin-bottom: 27px;" @click="viewMetrics()" :disabled="!modalSelectedProgram || !modalSelectedYear" class="btn btn-warning-arp">View Metrics</button>
                    </div>
                </div>
                <div class="metric-data-view" v-if="metricData">
                    <div class="metric-view" >
                        <div class="metric-view-title">
                            <div style="margin-right: 8px;">{{this.modalSelectedYearCopy.getUTCFullYear()}}</div>
                            <div style="margin-right: 8px;"> | </div>
                            <div>{{this.modalSelectedProgramCopy}}</div>
                        </div>
                        <div>
                            <!--<img src="../assets/img/edit-24px.svg" alt="edit img" />-->
                            <div @click="navToTargets()" class="back-link" style="font-size:15px;">CONFIGURE TARGETS</div>
                        </div>
                    </div>
                    <div v-if="hotSettings.data.length > 0" style="margin-top: 24px;">
                        <HotTable :settings="hotSettings" ref="hotTableComponent" :style="{ height: `${maxHeight - 464}px`, overflow: 'auto'}"></HotTable>
                        <!--
                        <div id="advanced-editor-example" class="hot">
                            <hot-table :settings="hotSettings">
                                <hot-column :width="150">
                                    <p hot-renderer>111</p>
                                </hot-column>
                                <hot-column v-for="n in 2" :width="150" v-bind:key="'col' + n">
                                    <p hot-renderer>222</p>                            
                                </hot-column>
                            </hot-table>
                        </div> -->
                    </div>
                    <div v-if="hotSettings.data.length === 0" style="margin-top: 24px;">
                        Please Wait...
                    </div>
                </div>
            </div>
            <div id="configureWrite" class="metric-configure-write">
                 <div v-if="renderEditSection" class="metric-edit-main">
                        <div class="metric-view-title" style="font-size: 22px;">Edit Metrics</div>
                        <div class="edit-selection">
                            <div class="selection-item" style="color: #A3A3A3; margin-right: 20px;">Metrics Name:</div>
                            <div class="selection-item">{{metricName}}</div>
                        </div>
                        <div>
                            <div class="filter-label">Category</div>
                            <div>
                                <input class="category-input" type="text" v-model="categoryValue" />
                            </div>
                        </div>
                        <div style="margin-bottom: 20px; width:250px">
                            <div class="filter-label">Decimal Rule</div>
                            <div>
                                <div class="decimal-box">
                                    <span @click="handleDecimalStep(-1)" class="decimal-action-button">-</span>
                                    <input class="decimal-input" disabled id="decimalInput" type="number" :value="this.decimalValue" v-on:keyup="decimalChangeHandler($event)" />
                                    <span @click="handleDecimalStep(1)" class="decimal-action-button">+</span>
                                </div>
                            </div>
                        </div>
                        <div style="border-top: 1px solid #C0C0C0; width:250px; margin-bottom: 20px;"></div>
                        <div style="margin-left: 60px;">
                        <button @click="closeMetricEdit()" class="btn btn-action-arp">Cancel</button>
                        <button @click="updateMetric()" class="btn btn-warning-arp" style="width: 90px;">SAVE</button>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HotTable, HotColumn } from '@handsontable-pro/vue';
import { mapActions, mapGetters } from 'vuex';
import Handsontable from 'handsontable-pro';
import "handsontable-pro/dist/handsontable.full.css";
import { parse } from 'path';
import Datepicker from '@hokify/vuejs-datepicker';
import { LICENSE_KEY } from "../Constants"

const editImageSource = 'src/assets/img/edit-24px.svg';

export default {
  name: "MetricConfiguration",
  components: {
        HotTable,
        HotColumn,
        'datepicker':Datepicker
        },
  methods: {
       ...mapActions(['getMetricData','editMetricData','getCommentsData','updateComments','updateOverlayParams','updateGetMetricParams','updateCommentaryParams','postEditComment','getMenuOptions','resetOverlay','editMetricsStatus']),
      goBackClick() {
            this.$router.push({name: 'Configuration'});
      },
      viewMetrics() {
          if (this.modalSelectedYear && this.modalSelectedProgram) {
              this.selectedRowIndex = "";
              this.editSelection = {};
              this.categoryValue = "";
              this.metricName = "";
              this.decimalValue = "";
              this.renderEditSection = false;
              document.getElementById("configureWrite").style.borderLeft = "0px solid #C0C0C0";
              // /metrics?id=<program_year> 
              this.updateGetMetricParams({program: this.modalSelectedProgram, year: this.modalSelectedYear.getUTCFullYear()});
              this.getMetricData();
              this.closeMetricEdit();
              this.metricData = true;
          }
      },
    
      editMetric(val, cords, c, d) {
          var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
          this.editSelection = {...this.hotSettings.data[htTable.toPhysicalRow(cords.row)]};
          this.selectedRowIndex = htTable.toPhysicalRow(cords.row);
          this.categoryValue = this.editSelection.category;
          this.metricName = this.editSelection.name;
          this.decimalValue = Number(this.editSelection.decimals);
          this.renderEditSection = true;
          document.getElementById("configureWrite").style.borderLeft = "2px solid #C0C0C0";
          val.stopPropagation();
        },
        closeMetricEdit() {
        this.renderEditSection = false;
        document.getElementById("configureWrite").style.borderLeft = "0";
     },
        updateMetric() {
            if(this.editSelection.category != this.categoryValue || this.editSelection.decimals != this.decimalValue){
            const body = {
                "metric_name": this.editSelection.name,
                "metric_decimal": this.decimalValue,
                "metric_category": this.categoryValue
            };
            this.editMetricData(body);
            }
            this.closeMetricEdit();
        },
        deleteMetric() {
            this.resetOverlay();
            this.updateOverlayParams({
                display: 'block',
                title: 'Delete Metric',
                message: 'Are you sure you want to delete this metric?',
                isNotification: false,
                buttons: {
                    type: 'challenge',
                    successHandler: () => {
                     // 
                    }
                },
                specialClassNames: 'delete-comment',
                duration: '',
                displayCloseIcon: true,
                background: true
            });
        },
        navToTargets () {
            if(this.modalSelectedYear.getFullYear()>=new Date().getFullYear())
            {
            const data = {
                program: this.modalSelectedProgram, year: this.modalSelectedYear.getUTCFullYear()
            }
            this.$router.push({name: 'targetsConfig', params: {data: JSON.stringify(data)}})
            }
            else{
                 this.$notify({
                        group: 'error',
                        text: 'Cannot configure metric targets for previous year...',
                        closeOnClick:true
                        });
            }
        },
    decimalChangeHandler(e) {
        if (!e.target.value) {
            this.decimalValue = '0';
            return;
        }
        const val = Math.round(Number(e.target.value));
        (val > 0 && val < 5) && this.decimalHistory.push(val);
        if (val < 0 || val > 4) {
            const index = this.decimalHistory.length - 1;
            const valid = this.decimalHistory[index];
            this.decimalValue = valid;
            // document.getElementById('decimalInput').innerText = this.decimalValue;
        } else {
            this.decimalValue = val;
        }
    },
    handleStatusChange(e, cords, td) {
        let data = [...this.hotSettings.data];
        var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
        let editSelection = {...this.hotSettings.data[htTable.toPhysicalRow(cords.row)]};
        if (data[htTable.toPhysicalRow(cords.row)].status.toLowerCase() === 'active') {
            data[htTable.toPhysicalRow(cords.row)].status = 'In-active';
        } else {
            data[htTable.toPhysicalRow(cords.row)].status = 'Active';
        }
        this.updateGetMetricParams({program: this.modalSelectedProgram, year: this.modalSelectedYear.getUTCFullYear()});
        /*
        {
            "metric_name": "Call Abandonment Rate",
            "metric_status": "active"
        }*/
         const body = {
                "metric_name": data[htTable.toPhysicalRow(cords.row)].name, //.toLowerCase()
                "metric_status": data[htTable.toPhysicalRow(cords.row)].status.toLowerCase()
            };
        this.editMetricsStatus(body);
        this.hotSettings.data = [...data];
        //this.getMetricData();
    },
    setYear(){ 
            this.modalselectedYear=new Date().getFullYear().toString();
         },
    displayRequiredYears(){
        let years=JSON.stringify(Object.keys(this.years))
        this.disabledDates.customPredictor= function(date) {
        if(years.toString().includes(date.getFullYear())){
                return false;
            }
            else{
                return true;
            }
        }
    },
    handleDecimalStep(step) {
        const futureVal = (Number(this.decimalValue) + step);
        if (futureVal < 0 || futureVal > 4) {
            //
        } else {
            this.decimalHistory.push(futureVal);
            this.decimalValue = futureVal;
        }
        /*
        Its possible to increase the number by
        0.1 when there are 0 decimal digits
        0.01 when there is 1 decimal digits.
        0.001, if there are 2 decimal digits
        0.0001, if there are 3 decimal digits.
        
        const split = this.decimalValue.toString().split('.');
        const decimalDigits = split && split.length > 1 ? split[1].length : 0;
        this.decimalValue = parseFloat(this.decimalValue);
        if (step > 0) {
            if (decimalDigits > 3) {
                this.decimalValue = parseFloat(this.decimalValue.toFixed(4));
                this.decimalValue = parseFloat((this.decimalValue + 0.0001).toFixed(4));
            } else if (decimalDigits > 0) {
                let num = "1";
                for(let i=0; i<decimalDigits; i++) {
                    num = num.concat('0')
                }
                num = num.concat('0');
                let stepFactor = (1/parseFloat(num));
                stepFactor = parseFloat(stepFactor.toFixed(decimalDigits + 1));
                this.decimalValue = parseFloat((this.decimalValue + stepFactor).toFixed(decimalDigits + 1));

            } else {
                this.decimalValue = parseFloat(this.decimalValue + 0.1).toFixed(1);
            }
        } else {
            if (this.decimalValue <= 0) {
                this.decimalValue = 0;
                return;
            }
             if (decimalDigits > 3) {
                this.decimalValue = parseFloat(this.decimalValue.toFixed(4));
                this.decimalValue = parseFloat((this.decimalValue - 0.0001).toFixed(4));
            } else if (decimalDigits > 0) {
                let num = "1";
                for(let i=0; i<decimalDigits; i++) {
                    num = num.concat('0')
                }
                num = num.concat('0');
                let stepFactor = (1/parseFloat(num));
                stepFactor = parseFloat(stepFactor.toFixed(decimalDigits + 1));
                this.decimalValue = parseFloat((this.decimalValue - stepFactor).toFixed(decimalDigits + 1));
            } else {
                this.decimalValue = parseFloat(this.decimalValue - 0.1).toFixed(1);
            }
        }
        */
    },
     
    searchInResults: function(searchTerm) {
        if(this.hotSettings.data!=='undefined' && this.hotSettings.data.length>0)
        {
            if(searchTerm.length>0)
            {
                 const filtersPlugin = this.$refs.hotTableComponent.hotInstance.getPlugin('filters');
                 filtersPlugin.removeConditions(0);
                 filtersPlugin.filter();
                 filtersPlugin.addCondition(0, 'contains', [searchTerm]);
                 filtersPlugin.filter();
                 var htTable =  this.$refs.hotTableComponent.hotInstance.getInstance();
                              if(htTable.countVisibleRows()==0)
                {
                      this.$notify({
                         group: 'error',
                         text: 'Result not found...',
                         closeOnClick:true
                         });
                }
            }
            else
            {
                 const filtersPlugin = this.$refs.hotTableComponent.hotInstance.getPlugin('filters');
                 filtersPlugin.removeConditions(0);
                 filtersPlugin.filter();
            }
        }
        else{
             if(searchTerm.length>0)
            {
             this.$notify({
                             group: 'error',
                             text: 'Select year and program name for searching...',
                             closeOnClick:true
                             });
             }
       }
    }
  },
  
  data: function() {
    let _this = this;
    return {
        maxHeight: innerHeight,
        selectedRowIndex: '',
        searchTerm: '',
        years: false,
        metricName: '',
        decimalHistory: [],
        //currentMetricData: [],
        modalPrograms: '',
        categoryValue: 'Billing, Enrollment',
        decimalValue: 12,
        modalSelectedYear: '',
        modalSelectedProgram: '',
        modalSelectedYearCopy: '',
        modalSelectedProgramCopy: '',
        metricData: false,
        renderEditSection: false,
        editSelection: {},
        disabledDates:{ customPredictor: function(date) {
                if(typeof this.years!=='undefined'){
            if(this.years.toString().includes(date.getFullYear())){
                    return false;
                }
                else{
                    return true;
                }
            }}},
        sortState: null,
        hotSettings: {
                data: [
                    /*
                    ['t', '12', 'A', '2.34'],
                    ['t', '12', 'A', '2.34'],

                    ['t', '12', 'A', '2.34'],

                   {
                        name: 'Test',
                        category: '1',
                        status: 'Active',
                        decimals: '0.876'
                    }*/
                ],
                licenseKey: LICENSE_KEY,
                stretchH: 'all',
                manualColumnResize: true,
                colHeaders: ['Metrics', 'Category', 'Status', 'Decimals'],
                columnSorting: {
                    indicator: true,
                    initialConfig: null
                },
                afterColumnSort(currentSortConfig, destinationSortConfigs) {
                    _this.sortState = destinationSortConfigs[0];
                },
                columns: [
                    {
                        data: 'name',
                        readOnly: true,
                        width: 160,
                        editor: false,
                        renderer: function(instance, td, row, col, prop, value, cellProperties) {
                            Handsontable.renderers.TextRenderer.apply(this, arguments);
                            let escaped = Handsontable.helper.stringify(value);
                            if (_this.selectedRowIndex === cellProperties.row) {
                                td.style.background = '#E7EAF2';
                            }
                            td.innerHTML = `<div>${escaped}</div>`;
                            return td;
                          },
                    },
                    {
                        data: 'category',
                        readOnly: true,
                        editor: false,
                        renderer: function(instance, td, row, col, prop, value, cellProperties) {
                            Handsontable.renderers.TextRenderer.apply(this, arguments);
                            let escaped = Handsontable.helper.stringify(value);
                            if (_this.selectedRowIndex === cellProperties.row) {
                                td.style.background = '#E7EAF2';
                            }
                            td.innerHTML = `<div>${escaped}</div>`;
                            return td;
                          },
                    },
                    {
                        data: 'status',
                        readOnly: true,
                         renderer: function(instance, td, row, col, prop, value, cellProperties) {
                            Handsontable.renderers.TextRenderer.apply(this, arguments);
                            let escaped = Handsontable.helper.stringify(value);
                            if (_this.selectedRowIndex === cellProperties.row) {
                                td.style.background = '#E7EAF2';
                            }
                            td.innerHTML = value && value.toLowerCase() == 'active' ? `<div style="padding-top: 5px; color:white !important; font-size: 10px;"><label class="switch"><input type="checkbox" checked><span class="slider round" style="margin-left:10px; width:60px; padding-left: 5px;" slot="Active">Active</span></label></div>` : `<div style="padding-top: 5px; font-size: 9px;right: 200px"><label class="switch"><input type="checkbox" ><span class="slider round" style= "width:60px; padding-left: 20px; margin-left:10px;" slot="In-active">In-active</span></label></div>`;
                          },
                        editor: false
                    },
                    {
                        data: 'decimals',
                        editor: false,
                        renderer: function(instance, td, row, col, prop, value, cellProperties) {
                            Handsontable.renderers.TextRenderer.apply(this, arguments);
                            let escaped = Handsontable.helper.stringify(value);
                            let icon, el;
                            if (_this.selectedRowIndex === cellProperties.row) {
                                td.style.background = '#E7EAF2';
                            }
                       td.innerHTML = `<div style="display: flex;flex-direction: row;    justify-content: space-between;"> <div>${value}</div> <div class="decimal-cell-buttons" style="display: flex; justify-content: flex-end; cursor: pointer;"> <div><svg style="padding: 0px; height: 20px; color: #2B779B" data-v-30a07fb4="" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="pencil-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class=" edit-svg-click svg-inline--fa fa-pencil-alt fa-w-16" style="color: blue;"><path class="edit-svg-click" data-v-30a07fb4="" fill="currentColor" d="M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z" class=""></path></svg></div> </div> </div>`;

                        return td;
                        }
                    }
                ],
                afterOnCellMouseDown: function(event, cords, TD) {
                    if (event && event.target && event.target.className == "slider round") {
                        _this.handleStatusChange(event, cords, TD);
                        return;
                    }
                    if (!event || !event.realTarget || !event.realTarget.className || !event.realTarget.className.baseVal) {
                        event.stopPropagation();
                        return;
                    }
                    if (event.realTarget.className.baseVal.indexOf("edit-svg-click") < 0) {
                        event.stopPropagation();
                        return;
                    }
                    _this.editMetric(event, cords, TD);
                },
                renderer: 'html',
                autoRowSize: false,
                autoColumnSize: false,
                disableVisualSelection: true,
                filters: true
            },
    };
  },
  computed: mapGetters(['currentCommentsMainCategory','currentCommentsSubCategory','currentCommentsYear','currentCommentsPeriod','currentCommentsData','isLoggedIn','currentUserName','currentMetricData','currentUserGroups','currentAccessLevel','currentCommentaryMenu', 'decimalValue']),
 watch: {
        editSelection: function() {
            const data = [...this.hotSettings.data];
            this.hotSettings.columnSorting.initialConfig = this.sortState;
            this.hotSettings.data = [...data];
        },
      currentCommentaryMenu: function(){
            this.years = this.currentCommentaryMenu;
        },
        currentMetricData: function() {
           this.modalSelectedYearCopy = this.modalSelectedYear;
           this.modalSelectedProgramCopy = this.modalSelectedProgram;
           const mkeys = Object.keys(this.currentMetricData);
           let dd = [];
            if(Object.keys(this.currentMetricData).length > 0) {
                mkeys.forEach((i, index) => {
                    let obj = {};
                    obj.category = this.currentMetricData[i].metric_category;
                    obj.decimals = (parseFloat(this.currentMetricData[i].metric_decimal || 0)).toString();
                    obj.name = mkeys[index];
                    obj.status = this.currentMetricData[i].metric_status;
                    dd.push(obj)
                });
                this.hotSettings.columnSorting.initialConfig = this.sortState;
                this.hotSettings.data = dd;
            }
        this.closeMetricEdit();
        },
         searchTerm: function()
      {
          this.searchInResults(this.searchTerm);
      },
      modalSelectedYear: function(){
            this.modalPrograms = [];
            if (this.modalSelectedYear.getUTCFullYear().toString().length > 0){
                this.modalPrograms = this.years[this.modalSelectedYear.getUTCFullYear()]['Providers'];
            }

            if(!this.modalPrograms.includes(this.modalSelectedProgram)) {
                this.modalSelectedProgram = '';
            }
        },
  },
  created(){
        this.getMenuOptions();
  }
};
</script>


<style>
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 20px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2B779B
}

input:focus + .slider {
  box-shadow: 0 0 1px #2B779B;
}

input:checked + .slider:before {
  -webkit-transform: translateX(33px);
  -ms-transform: translateX(33px);
  transform: translateX(33px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>

<style scoped>
.selection-item {
    font-size: 14px;
}
.decimal-box {
    display: flex;
    width: 254px;
    border: 1px solid #C0C0C0;    
    border-radius:5px;
}
.decimal-action-button {
    width: 60px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E7EAF2;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    border-radius:5px;
}
.decimal-input {
    width: 130px;
    height: 40px;
    text-align: center;
}
.category-input {
    width: 250px;
    height: 36px;
    padding-left: 6px;
    border: 1px solid #c0c0c0;
    border-radius: 5px;
}
.edit-selection {
    display: flex;
    flex-direction: row;
    margin-top: 25px;
}
.metric-edit-main {
    display: flex;
    flex-direction: column;
    margin-top: 28px;
}
.metric-configure-read {
    width: 740px;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #F4F4F4;
    height: inherit;
}
.metric-configure-write {
    width: 900px;
    padding: 20px;
    /* margin-top: 16px; */
    /* border-left: 2px solid #C0C0C0; */
    height: inherit;
    padding-top: 24px;
    padding-left: 24px;
    padding-right: 24px;
    background-color: #EEEEEE;
}
.handsontable .decimal-cell {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.handsontable th {
    background-color: #f0f0f0;
    color: #af2424;
    text-align: center;
    font-weight: bold;
    white-space: nowrap;
}
.metric-data-view {
    margin-top: 30px;
}
.metric-view {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.metric-view-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 18px;
 }
.form-field-aarp {
    margin-right: 24px;
}
.metric-form {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
}
.btn-action-arp {
    color: #000 !important;
    font-weight: bold !important;
    height: 34px;
    bottom: -2px;
    position: relative;
    padding: 3px 10px;
    width: 90px;
    border-radius: 5px;
}
.btn-warning-arp {
    color: #000 !important;
    background-color: #FBC743 !important;
    font-weight: bold !important;
    height: 34px;
    bottom: -2px;
    position: relative;
    padding: 3px 10px;
    width: 150px;
    border-radius:5px;

}
.filter-label {
    font-weight: bold;
    margin-bottom: 2px;
    margin-top: 26px;
}
.form-title {
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 20px;
    border-bottom: 2px solid #eeeeee;
    margin-bottom: 20px;
}
.search-metrics {
    border-radius: 30px;
    width: 300px;
    padding-left: 20px;
    border: 0;
    border: 1px solid #B1B9BE;
    height: 40px;
}
.search-metrics:focus {
    outline: none;
}
.back-link {
    color: rgb(43, 119, 155);
    cursor: pointer;
    padding: 3px 10px;
    font-size: 15px;
    font-weight: bold;
    margin-left: 20px;
    margin-top: 20px;
}
.configure-container {
  font-family: Arial;
  font-size: 16px;
  height: 100%;
}
.configure-title-section {
  top: 60px;
  left: 0px;
  width: 100%;
  height: 130px;
  background: #ffffff 0% 0% no-repeat padding-box;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.configure-title {
  margin-left: 28px;
  font-size: 26px;
  font-weight: 300;
  margin-top: 10px;
}
.configure-view-section {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  background-color: #eeeeee;
  margin: 0;
  padding: 0;
  /* height: 82vh; */;
}
</style>
